export default "__VITE_ASSET__ChT$mozf__"